import React, {forwardRef, useEffect, useMemo, useRef, useState} from "react";
import {Checkbox, Dropdown, type MenuProps, message,Tooltip} from "antd";
import {t} from "i18next";
import {openEditor} from "@/state";
import Global from "@/global";
import {getCardById, getCardCount, getCardDoc, updateCard, updateLastView} from "@model/card";
import {
    blobToBase64,
    checkIfAbsolute,
    formatDate,
    formatDateHms,
    generateRandomPageKey,
    generateUUID2,
    getFileIcon,
    getFileName,
    getImagePath,
    getImagePathSvg,
    getImagePathWithTheme, getImagePathWithThemeSvg,
    getJournalName,
    getLocalFilePath,
    hasDesktopBaseLicense,
    hasLicense,
    imgPathPerfix,
    isAbsoluteFilePath,
    isAnnoType, isAudio,
    isBaiduVideoUrl,
    isBilibiliUrl,
    isDarkMode,isDeepLink,
    isFreeCreateCardMode, isGif,isInJournal, isInPageProperties, isInPageTag, isInPageTagList, isInProjectList,
    isString,
    isYoutubeUrl
} from "@/utils";
import {ipcInvoke, ipcSend} from "@/common/ipc";
import {postMessage} from "@/common/event";
import {
    EVENT_FAVIRIATE_CHANGE,
    EVENT_NOTE_ON_SLIDER_RIGHT,
    EVENT_OPEN_LIBRARY_ITEM,
    EVENT_PDF_ON_SLIDER_RIGHT,
    EVENT_TEST_ONDRAG_NOTE, EVENT_VIDEO_ON_SLIDER_RIGHT, FROM_ADD, FROM_DIALOG, FROM_HOME_HIGHLIGHT, FROM_HOME_LIBRARY,
    FROM_LIBRARY, FROM_RIGHT_SIDEBAR,
    FROM_TAG,
    FROM_TRASH, KEY_CARD_SORT_TYPE,
    KEY_FILE_DIR, KEY_HIGHLIGHT_SORT_TYPE, MAP_WEEK_FULL, MAX_CARD_COUNT, usedColorToShowColor
} from "@/Const";
import Dragger from "antd/es/upload/Dragger";
import style from "@/views/Note/NoteItem/index.module.less";
import {
    IconAddToFavor,
    IconAddToProject, IconChangeSource,
} from "@/Icon";
import {createBreadcrumb, isGlobalRightSlider, isMac, updateFavorToFolder} from "@/Utility";
import {videoCache} from "../../../@excalidraw/packages/excalidraw/components/App";
import {useAtom} from "jotai";
import {atomSliderWidth} from "@/App";
import global from "@/global";
import {createLibraryItemMenu} from "@/MenuUtils";
import {dbGetHighlightByLibraryId, updateHighlight} from "@model/highlight";
import {atomCardItemPointerEvent} from "@/views/Home/HomeIndex";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import {isZh} from "@/language";
import EditorCardItem from "@/components/EditorV2/EditorCardItem";
import GridViewPropertyInfo from "@/views/Property/GridViewPropertyInfo";
import {getTransctiptById} from "@model/transcript";

let mIsSupportIcon = false;
let nItemCount = 4;
const CardItem = forwardRef((props:{data:any,searchKey?:any,itemWidth:any,itemHeight:any,withPropertyHeight?:any,isTrash:any,isShowChecked:boolean,from:string,subFrom?:any,onCheckedCallback:any,onActionCallback:any,onMouseUpCallback?:any,onGetCheckedData?:any,onRefreshList?:any,margin?:any,tableView?:any}, ref) => {

    const [menuItems,setMenuItems] = useState<MenuProps['items']>([]);
    const [isChecked,setIsChecked] = useState(false);
    const [isContextMenuOpen,setIsContextMenuOpen] = useState(false);
    const [itemWidth,setItemWidth] = useState(0);
    const [itemHeight,setItemHeight] = useState(((document.body.clientWidth - 246 - 20*2 - 12*4)/5) - 3);
    const [isHovered,setIsHovered] = useState(false);
    const [isHoverdMore,setIsHoverdMore] = useState(false);
    const [isShowMoreMenu_1,setIsShowMoreMenu_1] = useState(false);

    //判断是不是右侧栏打开了。。。。
    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    const [cardItemPointerEvent,setCardItemPointerEvent] = useAtom(atomCardItemPointerEvent);

    const mArrayMenuItems = useRef([]);
    const divItemRef = useRef(null);
    const [arrayTags,setArrayTags] = useState([]);
    // const [divItemRef,inView] = useInView({
    //     // threshold:0,
    //     rootMargin:`${document.body.clientHeight*0.8}px 0px`,
    //     root:document.getElementById(props.from == FROM_HOME_LIBRARY ? 'divCardItemContainer' : 'divCardItemContainer-from-other'),
    //     initialInView:true,
    // });


    useEffect(()=>{

        setIsChecked(props.data.isChecked);
        setItemWidth(props.itemWidth);
        setItemHeight(props.itemHeight);

        if (props.from == FROM_TRASH/* || props.from == FROM_TAG*/){
            window.addEventListener("resize",resizeWindow);
            resizeWindow();
        }

        //新建了收藏的文件夹要刷新这个列表...
        // window.refreshItemMenu = ()=>{
        //     refreshItemMenu();
        // }

        return ()=>{
            window.removeEventListener('resize',resizeWindow);
            // delete window.refreshItemMenu;
        }
    })

    useEffect(()=>{
        refreshItemMenu();
    },[props.data,props.isShowChecked,props.data?.isFavirated])


    /**
     * 右键菜单，转到上级去处理
     * @param e
     */
    const handleMenuClick = async (e: any) => {
        if (e.key == 'hiddenVisibleFromLibrary'){
            //显示或隐藏这个.
            if (props.data.isHidden == 1){
                props.data.isHidden = 0;
            }else{
                props.data.isHidden = 1;
            }
            //更新并刷新.
            updateCard(props.data).then(res=>{
                window.globalRefreshList('removeLibraryItems_',props.data.id);
            })
        }else{
            props.onActionCallback(e.key,props.data);
        }
    }

    const refreshItemMenu = ()=>{
        return new Promise(resolve => {
            let arrayMenus:any = createLibraryItemMenu(props.from,props.isShowChecked,props.data,async (key)=>{
                if (props.data.isFavirated){
                    props.data.isFavirated = 0;
                }else{
                    props.data.isFavirated = 1;
                }
                props.data.favirateTime = Date.now();
                //更新到favorfolder
                //把这个data插入到文件夹下..
                await updateFavorToFolder(key,props.data);

                updateCard(props.data,false).then(res=>{
                    postMessage(EVENT_FAVIRIATE_CHANGE);
                    if (props.onRefreshList){
                        props.onRefreshList();
                    }
                });
            });
            mArrayMenuItems.current.length = 0;
            mArrayMenuItems.current.push(...arrayMenus);

            setMenuItems(arrayMenus);
            if (isBilibiliUrl(props.data.url)){
                fetchBilibiImg()
            }

            resolve('ok')
        })
    }

    //加载bibilili的缩略图
    const fetchBilibiImg = ()=>{
        // const imageUrl = props.data.thumbImage;
        //
        // fetch(imageUrl, {
        //     headers: {
        //         Referer: 'https://www.bilibili.com', // 设置 Referer
        //     },
        // })
        //     .then(response => response.blob())
        //     .then(blob => {
        //         const img = document.getElementById('card-item-img-thumb-'+props.data.id);
        //         if (img){
        //             blobToBase64(blob).then(res=>{
        //                 img.src = res;
        //             })
        //         }
        //     })
        //     .catch(error => {
        //         console.error('加载图片失败:', error);
        //     });
    }

    /**
     * 调整窗口
     */
    function resizeWindow(){
        // const margin = 8;
        // const divContainer = document.getElementById('divPageLibaryContainer');
        // const nWidth = divContainer.clientWidth;
        // if (nWidth > 1480){
        //     nItemCount = 5;
        // }else if (nWidth > 1000){
        //     nItemCount = 4;
        // }else if (nWidth > 600){
        //     nItemCount = 3;
        // }
        // else{
        //     nItemCount = 2;
        // }

        if (/*props.from == FROM_TAG || */props.from == FROM_TRASH){
            nItemCount = 5;
        }
        // var item = document.getElementById("#divList");
        //左边菜单240 -- 间距margin左右各20  每个item的间距 8
        const nWidth0 = divItemRef.current?.clientWidth;//(document.body.clientWidth-241-(nItemCount)*(margin*2) - 30)/nItemCount;
        let nHeight = nWidth0*9/16;
        if (/*props.from == FROM_TAG ||*/ props.from == FROM_TRASH){
            nHeight = nWidth0*0.68;//和project中的保持一致。。。。因为缩略图的大小比例问题.
        }

        if (props.from == FROM_TRASH){
            nHeight += 4;
        }
        setItemWidth(nWidth0);
        setItemHeight(nHeight);
    }

    const isEmptyTitle = ()=>{
        if (props.data.hasTitle != undefined){
            if (!props.data.hasTitle){
                return true;
            }
        }
        if (isString(props.data?.name)){
            return !props.data?.name || props.data?.name?.toLowerCase() == t('Untitled').toLowerCase();
        }
        return true;
    }


    const patchMenuFavor = ()=>{
        setTimeout(()=>{
            const arrayMenus = document.getElementsByClassName('ant-dropdown-menu-submenu-title');
            for (let i=0;i<arrayMenus.length;i++){
                const item = arrayMenus[i];
                if (item.dataset?.menuId?.endsWith('-favor')){
                    item.onclick = function (event:any){
                        //这里是添加到根
                        handleMenuClick({key:'favor'});
                        setIsContextMenuOpen(false);
                    }
                }
            }
        },100)
    }

    const reContextMenu = async (e)=>{
        if (props.from == FROM_LIBRARY && props.subFrom == FROM_DIALOG) {
            setIsContextMenuOpen(false);
            return;
        }
        if (props.data.type == 'journal' && props.data.isEmpty) {
            setIsContextMenuOpen(false);
            message.error(t("NoOptionAvailable"));
            return;
        }
        if (e) {
            await refreshItemMenu();
        }

        const menu:any = [...mArrayMenuItems.current];
        if (props.isShowChecked && props.onGetCheckedData && e) {
            const arrayDatas = props.onGetCheckedData();
            let hasAnno = arrayDatas.some(p => (p.type == 'pdf' || p.type == 'pdfAnno' || p.type == 'video' || p.type == 'videoAnno'));

            if (hasAnno) {
                if (!menu.some(p => p.key == 'changeSource')) {
                    let changeSource = {
                        label: t("Change source"),
                        key: 'changeSource',
                        icon: <IconChangeSource/>
                    }
                    menu.splice(menu.length - 1, 0, changeSource);
                }
            } else {
                let nIndex = menu.indexOf(p => p.key == 'changeSource');
                for (let i=0;i<menu.length;i++) {
                    if (menu[i].key == 'changeSource') {
                        menu.splice(i, 1);
                        break;
                    }
                }
            }

            if (arrayDatas.some(p=>p.type == 'journal')){
                for (let i=0;i<menu.length;i++){
                    if (menu[i].key == 'deleteChecked'){
                        menu.splice(i,1);
                        break;
                    }
                }
            }
        }
        //判断一下文件是否存在..
        if (props.data.type == 'pdf' || props.data.type == 'audio' || props.data.type == 'video') {
            let szFilePath = props.data.fileName;
            if (!props.data.isAbsolutePath) {
                szFilePath = localStorage.getItem(KEY_FILE_DIR) + props.data.fileName;
            }
            const isExist = await ipcInvoke('is-file-exist', {filePath: szFilePath});
            if (!isExist && !menu.some(p => p.key == 'changeSource')){
                menu.splice(0, 0, {
                    label: t("Change source"),
                    key: 'changeSource',
                    icon: <IconChangeSource/>
                })
            }
        }

        setMenuItems(menu);
    }

    const getImageSrcThumb = ()=>{
        return getLocalFilePath(props.data.fileName, props.data.isAbsolutePath)+'?w=360';
    }

    /**
     * 渲染图片
     */
    const renderThumb = ()=>{
        mIsSupportIcon = false;
        if (props.data.type == 'audio' || props.data.type == 'file'){
            props.data.thumbImage = imgPathPerfix()+getFileIcon(props.data.fileName);
            mIsSupportIcon = true;
        }else if (props.data.type == 'baidu' || isBaiduVideoUrl(props.data.url)){
            props.data.thumbImage = getImagePathWithTheme("baidu.svg");
            mIsSupportIcon = true;
        }
        if (props.data.type == 'card' || props.data.type == 'journal'){
            //region card/journal
            return <div className={'hovered-home-border-0'} style={{
                position: 'absolute',
                left: '0',
                width: '100%',
                height: '100%',
                padding: '6px 16px 4px 16px',
                overflow: 'hidden',
                display: 'flex',
                borderRadius:'8px 8px 0 0',
                flexDirection: 'column',
            }}>
                {
                    props.data.type == 'journal' &&
                    <div className={'flex-row-vertical-center'} style={{
                        marginLeft: '2px',
                        marginBottom: '6px',
                        marginTop: '6px',
                        position: 'absolute',
                        width: '100%',
                        left: '0',
                        padding:'2px 16px'
                    }}>
                        {
                            false &&
                            <span className={'font-family-regular carditem-journal-title'}
                                  style={{
                                      display: 'block',
                                      color: 'var(--primary-color)',

                                  }}>{t(MAP_WEEK_FULL[`${(new Date(props.data.journalTime)).getDay()}`])}</span>
                        }

                        {
                            props.subFrom == 'journal' && props.data.isEmpty &&
                            <span className={'default-font-size'} style={{
                                color: 'var(--color-999)',
                                marginLeft: '4px',
                                marginTop: '0px'
                            }}>{t("NoEntryForThisDay")}</span>
                        }

                        <div style={{flexGrow: '1'}}></div>

                        {
                            props.subFrom == 'journal' &&
                            <>
                                {
                                    formatDate(new Date(), 'yyyyMMdd') == props.data.formatDate &&
                                    <span style={{
                                        background: 'var(--primary-color)',
                                        color: '#FFFFFF',
                                        borderRadius: '4px',
                                        marginLeft: 'auto',
                                        padding: '1px 8px',
                                        display: 'block'
                                    }}>{t("Today")}</span>
                                }
                                {
                                    // (new Date(props.data.journalTime).getDay() == 0 || new Date(props.data.journalTime).getDay() == 6) &&
                                    // <img style={{marginLeft:'auto'}} className={'img-20'} src={getImagePath('coofee')}/>
                                }
                            </>
                        }

                    </div>
                }

                {
                    !isEmptyTitle() && false &&/*(!props.tableView?.columns?.some(p=>p.id == 'name')) &&*/
                    <span id={'card-item-title-' + props.data.id} className={'font-family-semi-bold no-select'}
                          style={{
                              fontWeight:'600',
                              fontSize: '18px',
                              flexShrink: '0',
                              padding:'0 3px',
                              overflow: 'hidden',
                              width: '100%',
                              color:(props.subFrom == 'journal' && formatDate(new Date(),'yyyyMMdd') == props.data.formatDate)?'var(--primary-color)':'var(--text-color)'
                          }}>{props.data.type == 'journal'?getJournalName(props.data.journalTime):props.data.name}</span>
                }



                {/*<div className={'div-iframe-note'}*/}
                {/*     dangerouslySetInnerHTML={{__html: props.data.thumbHtml?.replace("html{", "xx{")}}*/}
                {/*     style={{*/}
                {/*         paddingBottom: '16px',*/}
                {/*         overflow: 'hidden',*/}
                {/*         fontSize: '12px',*/}
                {/*         marginTop: isEmptyTitle() ? '-4px' : '0px'*/}
                {/*     }}>*/}
                {/*</div>*/}
                <EditorCardItem data={props.data} from={props.from} itemHeight={props.itemHeight || itemHeight}/>

            </div>
            //endregion
        }else if (props.data.type == 'add'){
            return <div className={'flex-column-center hovered-home-border-0'} style={{position: 'absolute', height: `${props.withPropertyHeight}px`, width: '100%', left: '0', fontSize: '12px',borderRadius:'8px',overflow:'hidden'}}>
                <img className={'img-16'} src={imgPathPerfix()+'add_gray.png'}/>
                <span className={'mt-6'} style={{color:'var(--color-a5a5a5)'}}>{props.data.name}</span>
            </div>
        }else if (props.data.type == 'pdfAnno' || props.data.type == 'cardAnno'){
            //region pdfAnno
            return <div className={'hovered-home-border-0'}  style={{padding:'8px',position: 'absolute',
                left: '0',
                width: '100%',
                height: '100%'}}>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: '12px',
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingBottom: '6px',
                        height:'100%',
                        overflow:'hidden',
                    }}>
                    {
                        false &&
                        <>
                            <div style={{display: 'flex', alignItems: 'center', flexShrink: '0px'}}><span
                                style={{
                                    color: usedColorToShowColor(props.data.color),
                                    border: `1px solid ${usedColorToShowColor(props.data.color)}`,
                                    width: '18px',
                                    height: '18px',
                                    display: 'flex',
                                    justifyItems: 'center',
                                    justifyContent: 'center',
                                    flexShrink: '0',
                                    minHeight: '18px',
                                }}>A</span><span
                                style={{
                                    marginLeft: '4px',
                                    color: usedColorToShowColor(props.data.color),
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden'
                                }}>{"" + props.data.name}</span>
                            </div>
                            <div
                                style={{
                                    height: '1px',
                                    background: '#E4E4E4',
                                    marginTop: '6px',
                                    marginLeft: '-16px',
                                    marginRight: '-16px'
                                }}></div>
                        </>
                    }

                    {
                        props.data.annoType == "highlight" &&
                        <div>
                            <blockquote
                                style={{
                                    marginTop: '10px',
                                    marginLeft: '0px',
                                    marginRight: '0px',
                                    paddingLeft: '8px',
                                    borderLeft: `2px solid ${usedColorToShowColor(props.data.color)}`,
                                    textAlign: 'left'
                                }}>
                                  <span style={{
                                      color: isDarkMode() ? 'var(--text-color)' : 'var(--text-color)',
                                      marginTop: '4px'
                                  }}>{props.data.text}</span>
                            </blockquote>
                            <span style={{
                                paddingTop: '4px',
                                display: 'block',
                                whiteSpace: 'pre',
                                textWrap: 'wrap'
                            }}>{props.data.comment}</span>
                        </div>
                    }
                    {
                        props.data.annoType == 'image' &&
                        <div>
                            <img draggable={false} src={props.data.thumbImage} style={{
                                width: '100%',
                                height: 'auto',
                            }}/>
                            <span style={{paddingTop: '4px', display: 'block',whiteSpace:'pre',textWrap:'wrap'}}>{props.data.comment}</span>
                        </div>

                    }
                </div>
            </div>
            //endregion
        }else if (props.data.type == 'videoAnno' || props.data.type == 'audioAnno'){
            //region videoAnno
            return <div className={'hovered-home-border-0'}  style={{padding:'0 8px 8px 8px',position: 'absolute',
                left: '0',
                width: '100%',
                height: '100%'}}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: '12px',
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingBottom: '6px',
                        height:'100%',
                        overflow:'hidden',
                    }}>
                    {
                        false &&
                        <>
                            <div style={{display: 'flex', alignItems: 'center', flexShrink: '0px'}}>
                                <img className={'img-16'} src={getImagePath('library_video_anno')}/>
                                <span style={{
                                    marginLeft: '4px',
                                    color: '#FF9500',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden'
                                }}>{props.data.name || t("Untitled")}</span>
                                <span style={{
                                    marginLeft: 'auto',
                                    color: 'var(--color-666666)'
                                }}>{formatDateHms(props.data.time)}</span>
                            </div>
                        </>
                    }

                    <div>
                        <span style={{
                            color: isDarkMode() ? 'var(--text-color)' : '#000000',
                            fontSize: '16px',
                            display: 'block',
                            marginTop: '10px'
                        }}>{props.data.title}</span>
                        <span style={{paddingTop: '4px', display: 'block'}}>{props.data.content}</span>
                        {
                            props.data.thumbImage &&
                            <img style={{objectFit: 'contain', width: '100%', borderRadius: '4px', marginTop: '6px'}} src={getLocalFilePath(props.data.thumbImage,props.data.isAbsolutePath)}/>
                        }
                    </div>
                </div>
            </div>
            //endregion
        }else if (props.data.type == 'webLink'){
            //region weblink
            return <div className={'hovered-home-border-0'} style={{display:'grid',
                gridTemplateColumns:props.data.thumbImage ?'38% 62%':'100%',
                padding:props.data.thumbImage?'0px':'2px 4px',
                position: 'absolute',
                left: '0',
                width: '100%',
                fontSize:'12px',
                overflow:'hidden',
                height: '100%'}}>
                {
                    props.data.thumbImage &&
                    <img draggable={false} style={{objectFit: 'cover', overflow: 'hidden', width: '100%', height: '100%'}}
                         src={props.data.thumbImage}/>
                }

                <div className={'flex-col'} style={{padding: '6px 8px', height: itemHeight + 'px'}}>
                    <div className={'flex-row-vertical-center'}>
                        <img className={'img-12'} style={{flexShrink:'0'}} src={props.data.icon || getImagePathWithThemeSvg('default_web_icon')}/>
                        <span className={'span-single-line ml-4'} style={{color:'var(--text-color-bab8b8)'}}>{props.data.fileName}</span>
                    </div>
                    <div className={'font-family-semi-bold'} style={{margin: '4px 0',fontSize:'14px',fontWeight:'800'}}>{props.data.name}</div>

                    <div id={'weblink-content-' + props.data.id} style={{
                        display: 'flex',
                        flexWrap:'wrap',textOverflow:'ellipsis',overflow:'hidden',color: 'var(--text-color-66666)'}}>
                        {/*<span style={{*/}
                        {/*    color: 'var(--text-color-66666)',*/}
                        {/*    textOverflow: 'ellipsis'*/}
                        {/*}}>{props.data.description}</span>*/}
                        {props.data.description}
                    </div>
                </div>
            </div>
            //endregion
        }else if (props.data.type == 'row' && !isDeepLink(props.data.link)){
            //region row
            return <div className={'hovered-home-border-0'}  style={{padding:'0 8px 8px 8px',position: 'absolute',
                left: '0',
                width: '100%',
                height: '100%'}}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: '12px',
                        paddingLeft: '6px',
                        paddingRight: '6px',
                        paddingBottom: '6px',
                        height:'100%',
                        overflow:'hidden',
                    }}>

                    <div>
                        <span style={{
                            color: isDarkMode() ? 'var(--text-color)' : '#000000',
                            fontSize: '16px',
                            display: 'block',
                            marginTop: '10px'
                        }}>{props.data.title}</span>
                        <span style={{paddingTop: '4px', display: 'block'}}>{props.data.content}</span>
                        {
                            props.data.thumbImage &&
                            <img style={{objectFit: 'contain', width: '100%', borderRadius: '4px', marginTop: '6px'}} src={getLocalFilePath(props.data.thumbImage,props.data.isAbsolutePath)}/>
                        }
                    </div>
                </div>
            </div>
            //endregion
        }
        else {
            return <div className={'hovered-home-border-0'} style={{
                position: 'absolute',
                height: '100%',
                width: '100%',
                left: '0',
                fontSize: '12px',
                borderRadius: '8px 8px 0 0',
                overflow: 'hidden'}}>

                {
                    (props.data?.type == 'image' || props.data?.type == 'pdf' || props.data?.type == 'video')? <LazyLoadImage id={'card-item-img-thumb-' + props.data.id}
                                                                   visibleByDefault={false}
                                                                   draggable={false}
                                                                   wrapperProps={{
                                                                       style:{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}
                                                                   }}

                                                                   placeholderSrc={getImagePath('image_loading')}
                                                                   src={props.data.type == 'image' ? getImageSrcThumb() : props.data.thumbImage}
                                                                   style={{
                                                                       // position: 'absolute',
                                                                       // left: '50%',
                                                                       // top: '50%',
                                                                       // transform: 'translate(-50%,-50%)',
                                                                       width: mIsSupportIcon ? '80px' : '100%',
                                                                       height: mIsSupportIcon ? '80px' : '100%',
                                                                       // width: mIsSupportIcon ? '80px' : itemWidth+'px',
                                                                       // height: mIsSupportIcon ? '80px' : itemHeight+'px',
                                                                       objectFit: 'cover'
                                                                   }} effect={'blur'}/>:
                        <img id={'card-item-img-thumb-' + props.data.id}
                             draggable={false}
                                       src={props.data.type == 'image' ?(getLocalFilePath(props.data.fileName, props.data.isAbsolutePath)+'?w=360') : props.data.thumbImage}
                                       style={{
                                           position: 'absolute',
                                           left: '50%',
                                           top: '50%',
                                           transform: 'translate(-50%,-50%)',
                                           width: mIsSupportIcon ? '80px' : '100%',
                                           height: mIsSupportIcon ? '80px' : '100%',
                                           objectFit: 'cover'
                                       }}/>
                }



                {
                    (props.from != FROM_TAG || (props.tableView && props.tableView.columns.length == 0)) && false &&
                    <div style={{
                        height: '30px',
                        background: 'rgba(0,0,0,.66)',
                        position: 'absolute',
                        width: '100%',
                        bottom: '0px'
                    }}>
                        <span className={'flex-center span-single-line'} style={{
                            position: 'absolute',
                            bottom: '0px',
                            fontSize: '13px',
                            height: '30px',
                            width: props.data.highlightsCount > 0 ? 'calc(100% - 90px)' : '100%',
                            lineHeight: '30px',
                            color: 'white', padding: '0 12px', display: 'block', overflow: 'hidden'
                        }}>{props.data.name}</span>
                        {
                            props.data.highlightsCount > 0 &&
                            <span className={'flex-center'} style={{position:'absolute',bottom:'0px',height:'30px',right:'8px',color:'white'}}>{`${props.data.highlightsCount} `+t("Ge")+t('Highlights')}</span>
                        }

                    </div>
                }
                {
                    (props.data.type == 'video' || props.data.type == 'youtube' || props.data.type == 'bilibili') &&
                    <>
                        {
                            isYoutubeUrl(props.data.url || props.data.fileName) ?
                                <img draggable={false} style={{
                                    width: '60px',
                                    height: '60px',
                                    position: "absolute",
                                    zIndex: '9',
                                    left: '50%',
                                    top: '50%',
                                    opacity:isBaiduVideoUrl(props.data.url)?'0':'1',
                                    transform: 'translate(-50%,-50%)'
                                }}
                                     src={imgPathPerfix() + (props.data.type == 'youtube' ? 'youtube_play.png' : 'video_play.png')}/> :
                                <img draggable={false} style={{
                                    width: '60px',
                                    height: '60px',
                                    position: "absolute",
                                    zIndex: '9',
                                    left: '50%',
                                    top: '50%',
                                    opacity:isBaiduVideoUrl(props.data.url)?'0':'1',
                                    transform: 'translate(-50%,-50%)'
                                }}
                                     src={imgPathPerfix() + ('video_play.png')}/>
                        }
                    </>
                }
                {/*<div style={{position:"absolute",left:'0',top:'0',width:'100%',height:'100%',background:isHoverd?'rgba(0, 0, 0, 0.12)':'rgba(0, 0, 0, 0)'}} className={'hovered-home-dark'}></div>*/}
            </div>
        }
    }

    const isInLibrary = ()=>{
        return props.from == FROM_LIBRARY || props.subFrom == FROM_LIBRARY || props.from == FROM_HOME_LIBRARY
    }

    const getItemHeight = ()=>{
        if (props.withPropertyHeight){
            return props.withPropertyHeight;
        }
        if (props.from == FROM_TRASH){
            return itemHeight + 38;
        }
        return itemHeight;
    }

    const getMarginTop = ()=>{
        if (props.data.type == 'card'){
            if (props.data.hasTitle == false || !props.data.name){
                return '10px';
            }
        }
        return '0px';
    }

    return (
        // <Draggable
        //         onStart={()=>{
        //                setDragState({...dragState,activeDrags: ++dragState.activeDrags});
        //            }}
        //            onDrag={()=>{
        //
        //            }}
        //
        //            onStop={()=>{
        //                setDragState({...dragState,activeDrags: ++dragState.activeDrags});
        //            }}>
        <Dropdown overlayClassName='default-dropdown-style' menu={{items: menuItems, onClick: handleMenuClick}}
                  trigger={['contextMenu']} open={isContextMenuOpen} onOpenChange={async (e) => {

                      reContextMenu(e);
            //last result 一样显示所有.
            setIsContextMenuOpen(e);

            if (e) {
                setTimeout(() => {
                    patchMenuFavor();
                }, 100)
            }
        }}>
            <div ref={divItemRef} id={'card-item-id-'+props.data.id} className={((props.from == FROM_HOME_LIBRARY || props.from == FROM_TAG)?'carditem':'carditem-from-library') + (props.data.isChecked?` hovered-home-border-checked`:' hovered-home-border') + ' hovered-some-image'}
                 data-id = {props.data.id}
                 style={{margin:(props.margin || '0px'),display:'flex',alignItems:'center',
                     // border: props.data.isChecked ? '1px solid var(--link-color)' : '1px solid transparent',
                     borderRadius: '8px',
                     overflow:(props.from == FROM_TAG || (props.tableView && props.tableView?.columns?.length == 0))?'hidden':'hidden',
                     cursor:'pointer',
                     pointerEvents:cardItemPointerEvent,height: (getItemHeight()) + 'px',
                     flexDirection:'column',
            }}
                 onMouseEnter={() => {
                     setIsHovered(true)
                 }} onMouseLeave={() => setIsHovered(false)}
                 onMouseUp={props.onMouseUpCallback}
                 onClick={async (event) => {
                     //region click
                global.g_isCtrlPressed = false;
                if (props.from == FROM_TRASH) {
                    return;
                }
                if (event.ctrlKey || event.metaKey) {
                    global.g_isCtrlPressed = true;
                    setTimeout(() => {
                        global.g_isCtrlPressed = false;
                    }, 2000);
                }
                if (props.subFrom == FROM_DIALOG) {
                    let data = await getCardById(props.data.id,true);//这里重新获取。。
                    if (props.data.type == 'add' && props.data.createType == 'card') {

                        if (!hasLicense() && !hasDesktopBaseLicense()) {
                            const nCount = await getCardCount();
                            if (nCount > MAX_CARD_COUNT && !isFreeCreateCardMode()) {
                                window.showMessageBox(t("Upgrade required"), t("YouNeedToUpgradeCreateCard"), t("Cancel"), t("Learn more"), null, () => {
                                    if (isZh()) {
                                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                    } else {
                                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                    }
                                })
                                return;
                            }
                        }

                        //作为一个新卡片
                        data = {
                            id: generateUUID2(),
                            doc: '',
                            isDeleted: 0,
                            name: global.g_newCardTitle,
                            type: 'card',
                            thumbHtml: '',
                            createTime: Date.now()
                        }
                        global.g_newCardTitle = '';

                        await updateCard(data)
                    }
                    props.onActionCallback('', data);
                    return;
                }


                if (props.isShowChecked) {
                    setIsChecked(!isChecked);
                    props.data.isChecked = !isChecked;
                    props.onCheckedCallback(props.data);
                } else {
                    // if (props.from == FROM_LIBRARY) {
                    //     message.info(t("YouCanDragThe"));
                    //     return;
                    // }else
                    if (props.from == FROM_ADD) {
                        //添加...
                        props.onActionCallback('select', props.data);
                        return;
                    }

                    //点击就更新...
                    let szSortType = localStorage.getItem(KEY_HIGHLIGHT_SORT_TYPE);
                    let szSortType1 = localStorage.getItem(KEY_CARD_SORT_TYPE);
                    updateLastView(props.data.id, (szSortType == 'sort by updateDate' || szSortType1 == 'sort by updateDate'));

                    let isInGlobalRight = window.location.href.includes('/library') || window.location.href.includes('/tags') || isInPageTagList() || isInProjectList();

                    if (props.data.type == 'card' || props.data.type == 'journal') {
                        if (!global.g_isCtrlPressed && props.from == FROM_LIBRARY) {
                            //从侧栏库中点击的，直接在侧栏打开...
                            if (isGlobalRightSlider() || isInGlobalRight) {
                                window.openRightSlider(props.data, props.data.type, {forceType: 'library'});
                            } else {
                                postMessage(EVENT_NOTE_ON_SLIDER_RIGHT, {
                                    data: props.data,
                                    breadcrumb: createBreadcrumb("library", props.data.name)
                                })
                            }
                        } else {
                            const doc = await getCardDoc(props.data.id);
                            Global.g_currentNoteData = {...props.data, doc};
                            openEditor(props.data.id, false, props.from == FROM_LIBRARY, props.from, props.data.type).then(res=>{
                                //自动打开搜索，如果有搜索的话.
                                if (props.searchKey) {
                                    setTimeout(() => {
                                        window.GSearchOpen(props.searchKey, true);
                                    }, 500)
                                }
                            });

                        }
                    } else if (props.data.type == 'pdf') {
                        if (!global.g_isCtrlPressed && props.from == FROM_LIBRARY) {
                            let szFilePath = localStorage.getItem(KEY_FILE_DIR) + props.data.fileName;
                            if (checkIfAbsolute(props.data.fileName)) {
                                szFilePath = props.data.fileName;
                            }
                            ipcInvoke('read-file-absolute-path', {filePath: szFilePath}).then(res => {
                                const blob = new Blob([res]);
                                const url = URL.createObjectURL(blob);
                                if (isGlobalRightSlider() || isInGlobalRight) {
                                    window.openRightSlider(props.data, props.data.type);
                                } else {
                                    postMessage(EVENT_PDF_ON_SLIDER_RIGHT, {
                                        pdfPath: url,
                                        fileId: props.data.id,
                                        fileName: props.data.name,
                                        pdfFileName: props.data.name,
                                        breadcrumb: createBreadcrumb("library", props.data.name)
                                    });
                                }
                            })
                        } else {
                            if (props.from == FROM_HOME_HIGHLIGHT) {
                                if (props.subFrom == FROM_LIBRARY) {
                                    let szFilePath = localStorage.getItem(KEY_FILE_DIR) + props.data.fileName;
                                    if (checkIfAbsolute(props.data.fileName)) {
                                        szFilePath = props.data.fileName;
                                    }
                                    ipcInvoke('read-file-absolute-path', {filePath: szFilePath}).then(res => {
                                        const blob = new Blob([res]);
                                        const url = URL.createObjectURL(blob);
                                        if (rightSliderWidth > 0) {
                                            window.openRightSlider(props.data, props.data.type, {
                                                isViewAllHighlight: true,
                                                breadcrumb: 'highlight'
                                            });
                                        } else {
                                            postMessage(EVENT_PDF_ON_SLIDER_RIGHT, {
                                                pdfPath: url,
                                                fileId: props.data.id,
                                                fileName: props.data.name,
                                                pdfFileName: props.data.name,
                                                isViewAllHighlight: true,
                                                breadcrumb: createBreadcrumb("highlight", props.data.name)
                                            });
                                        }
                                    })
                                } else {
                                    window.showPdfPreview(props.data.name, props.data.id, props.data.fileName, false, true, false);
                                }

                            } else {
                                window.showPdfPreview(props.data.name, props.data.id, props.data.fileName);
                            }
                        }
                    } else if (props.data.id == '-1') {
                        // Global.g_currentNoteData = {id:generateRandomPageKey()}
                        // openEditor(Global.g_currentNoteData.id,false,false);
                        if (!hasLicense() && !hasDesktopBaseLicense()) {
                            const nCount = await getCardCount();
                            if (nCount > MAX_CARD_COUNT && !isFreeCreateCardMode()) {
                                window.showMessageBox(t("Upgrade required"), t("YouNeedToUpgradeCreateCard"), t("Cancel"), t("Learn more"), null, () => {
                                    if (isZh()) {
                                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE_ZH)
                                    } else {
                                        ipcSend('open-url', import.meta.env.VITE_HTTP_PURCHASE_PRICE);
                                    }
                                })
                                return;
                            }
                        }

                        props.onActionCallback('add', props.data);
                    } else if (props.data.type == 'pdfAnno' || props.data.type == 'cardAnno') {
                        window.showDialogPdfAnno(props.data);
                    } else if (props.data.type == 'videoAnno' || props.data.type == 'audioAnno') {
                        // if (!isString(props.data.src)) {
                        //     props.data.src = props.data.src?.link;
                        // }
                        window.showDialogVideoAnno(props.data);
                    } else if (props.data.type == 'webLink') {
                        ipcSend('open-url', props.data.fileName);
                    }else if (props.data.type == 'row'){
                        //直接编辑name----
                        window.showDialogTiptapTextEditorView(props.data);
                    }
                    else {
                        if (!global.g_isCtrlPressed && (props.from == FROM_HOME_HIGHLIGHT || props.from == FROM_LIBRARY) /*|| props.from == FROM_TAG*/) {
                            //视频...
                            if (props.subFrom == FROM_LIBRARY) {
                                if (props.data.type == 'image') {
                                    window.showDialogMediaView(props.data);
                                } else if (props.data.type == 'file') {
                                    let szFilePath = localStorage.getItem(KEY_FILE_DIR) + props.data.fileName;
                                    if (props.data.isAbsolutePath) {
                                        szFilePath = props.data.fileName;
                                    }
                                    ipcInvoke('open-url-withwhen', szFilePath).then(res => {
                                        if (res == 'error') {
                                            message.error(t("Open error"));
                                        }
                                    })
                                } else {
                                    let highlight = await dbGetHighlightByLibraryId(props.data.id);
                                    if (!highlight) {
                                        highlight = {...props.data, libraryId: props.data.id};
                                        if (!highlight.url) {
                                            highlight.url = props.data.fileName;
                                        }
                                    } else {
                                        if (props.data.name) {
                                            if (props.data.name != highlight.name) {
                                                highlight.name = props.data.name;
                                                //更新
                                                updateHighlight(highlight);
                                            }
                                        }
                                    }

                                    let szElementType = 'embeddable';
                                    if (highlight.type == 'audio' || highlight.type == 'video') {
                                        szElementType = 'iframe';
                                    }

                                    const element = {
                                        id: highlight.id,
                                        name: props.data.name,
                                        type: szElementType,
                                        customData: {
                                            generationData: {
                                                type: 'file',
                                                id: highlight.libraryId || highlight.id,
                                                name: highlight.name,
                                                fileName: highlight.fileName
                                            }
                                        },
                                        link: highlight.url,
                                        src: highlight.url,
                                        videoNotes: highlight.data,
                                    }
                                    //保存这个元素的笔记到缓存....
                                    videoCache.set(highlight.id, highlight.data);

                                    if (rightSliderWidth > 0) {
                                        window.openRightSlider({
                                            id: highlight.id,
                                            videoNotes: {element: element},
                                            isVideo: true,
                                            name: highlight.name || element.name
                                        }, props.from == FROM_HOME_HIGHLIGHT ? 'highlight' : 'library');
                                    } else {
                                        postMessage(EVENT_VIDEO_ON_SLIDER_RIGHT, {
                                            videoNotes: {element: element},
                                            breadcrumb: createBreadcrumb(props.from == FROM_HOME_HIGHLIGHT ? 'highlight' : 'library', props.data.name)
                                        });
                                    }
                                }
                            } else {
                                const highlight = await dbGetHighlightByLibraryId(props.data.id);
                                const transcript = await getTransctiptById(props.data.id);
                                if (transcript) {
                                    if (highlight) {
                                        window.showVideoNotes(highlight);
                                    }else {
                                        window.showVideoNotes({...props.data, data: []});
                                    }
                                    return;
                                }

                                if (highlight) {//有视频注记，用视频注记打开
                                    if (!highlight.name) {
                                        highlight.name = props.data.name;
                                    }
                                    window.showVideoNotes(highlight);
                                } else {
                                    //同一个东西，不同的打开地方显示的东西各不相同。---- 可能是这样，也可能是那样。。
                                    if (props.data.type == 'audio' || props.data.type == 'image' || (props.data.type == 'video' && (!highlight || (highlight && highlight.data?.length == 0)))) {
                                        window.showDialogMediaView(props.data);
                                    } else {
                                        let szFilePath = localStorage.getItem(KEY_FILE_DIR) + props.data.fileName;
                                        if (props.data.isAbsolutePath || isAbsoluteFilePath(props.data.fileName)) {
                                            szFilePath = props.data.fileName;
                                        }
                                        ipcInvoke('open-url-withwhen', szFilePath).then(res => {
                                            if (res == 'error') {
                                                message.error(t("Open error"));
                                            }
                                        })
                                    }
                                }
                                // window.showVideoNotes(props.data);
                            }
                        } else {
                            const transcript = await getTransctiptById(props.data.id);
                            const highlight = await dbGetHighlightByLibraryId(props.data.id);
                            if (transcript) {
                                if (highlight) {
                                    window.showVideoNotes(highlight);
                                }else {
                                    window.showVideoNotes({...props.data, data: []});
                                }
                                return;
                            }

                            if (props.data.type == 'image' || (props.data.type == 'video' && (!highlight || (highlight && highlight.data?.length == 0)))) {
                                window.showDialogMediaView(props.data);
                            }
                            //图片和视频
                            else if (props.data.type == 'video' || props.data.type == 'audio' || props.data.type == 'youtube' || props.data.type == 'bilibili' || props.data.type == 'baidu') {
                                if (highlight) {//有视频注记，用视频注记打开
                                    if (!highlight.name) {
                                        highlight.name = props.data.name;
                                    }
                                    window.showVideoNotes(highlight);
                                } else {
                                    if (props.from == FROM_HOME_LIBRARY || props.from == FROM_LIBRARY || props.from == FROM_TAG) {
                                        //强制使用highlight模式
                                        window.showVideoNotes({
                                            ...props.data,
                                            data: [],
                                            type: props.data.type || 'youtube'
                                        });
                                    } else {
                                        window.showDialogMediaView(props.data);
                                    }
                                }

                            } else {
                                let szFilePath = localStorage.getItem(KEY_FILE_DIR) + props.data.fileName;
                                if (props.data.isAbsolutePath || isAbsoluteFilePath(props.data.fileName)) {
                                    szFilePath = props.data.fileName;
                                }
                                ipcInvoke('open-url-withwhen', szFilePath).then(res => {
                                    if (res == 'error') {
                                        message.error(t("Open error"));
                                    }
                                })
                            }
                        }
                    }
                }
                //endregion
            }}>
                <div className={'div-card-item-first-child'} style={{borderRadius:'8px 8px 0px 0px',overflow:'hidden',
                    height: props.data.id == -1?'100%':((props.from == FROM_TAG?props.itemHeight:itemHeight) + 'px'),width:'100%',
                    flexShrink:'0',
                    // paddingTop:getMarginTop(),
                    display:'flex',alignItems:'center',flexDirection:'column',}}>
                {
                    (/*inView || !isInLibrary() ||*/ true) ? <div draggable={props.from == FROM_LIBRARY || props.subFrom == FROM_LIBRARY}
                                  className={'second-child list-item-hover hovered-home-dark card-ii-t-em'} style={{
                        position: 'relative',
                        // visibility: props.data.id == -1 ? 'hidden' : 'visible',
                        // width: itemWidth + 'px',
                        height: props.data.id == -1?'100%':(itemHeight + 'px'),
                        flexShrink:'0',
                        width: '100%',
                        contain: 'strict',//这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********这个属性解决拖动不应该出现的残影问题*********
                        background: itemHeight == 0 ? 'transparent' : ((props.subFrom == 'journal' && props.data.isEmpty) ? 'var(--journal-empty-item-background-color)' : (props.subFrom == 'journal' ? 'var(--home-library-item-background-color)' : 'var(--home-library-item-background-color)')),//服了，设计一次换一种-----
                        // border: props.data.isChecked ? '1px solid var(--link-color)' : '1px solid transparent',
                        // borderRadius: '8px',
                        overflow: 'hidden',
                        /*margin: '10px 8px'*,*/
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                                  onDragStart={(e) => {
                                      // html2canvas(e.target, {
                                      //     scale: 1,
                                      // }).then((canvas) => {
                                      //
                                      // }).catch(res=>{
                                      //
                                      // });

                                      // const dragImg = new Image();
                                      // dragImg.src = getImagePathWithTheme('recent');
                                      // e.dataTransfer.setDragImage(dragImg, 0, 0);
                                      props.onMouseUpCallback();
                                  }} onDragEnd={(event) => {
                        const dragData = {
                            id: props.data.id,
                            type: props.data.type,
                            x: event.clientX,
                            y: event.clientY
                        }
                        postMessage(EVENT_TEST_ONDRAG_NOTE, dragData);
                        if (window.location.href.endsWith("/card") || window.location.href.endsWith('/journal') || window.location.href.endsWith("/draw") || window.location.href.endsWith('/defaultProject')) {
                            global.g_currentDragLibraryItem = {...props.data};
                        }
                    }}>
                        {renderThumb()}

                        {
                            props.isShowChecked &&
                            <Checkbox checked={isChecked}
                                      style={{position: "absolute", right: '6px', top: '6px', zIndex: '3'}}
                                      onClick={(event) => {
                                          setIsChecked(!isChecked);
                                          props.data.isChecked = !isChecked;
                                          props.onCheckedCallback(props.data);
                                      }}/>
                        }

                        {
                            props.data.isAbsolutePath &&
                            //link
                            <img className={'img-30'} style={{position: 'absolute', left: '0px', top: '0px'}}
                                 src={getImagePathWithTheme('out_link_sign.svg')}/>
                        }


                        {
                            // isHoverd && !props.isShowChecked && props.from != FROM_LIBRARY && props.from != FROM_TAG &&
                            // <div data-type={'more'} style={{position:'absolute',right:'16px',top:'12px'}}
                            //      onClick={(e) => e.stopPropagation()}>
                            //     <Dropdown menu={{items: menuItems, onClick: handleMenuClick}} onOpenChange={(e)=>{
                            //
                            //     }}>
                            //         <img style={{width: '16px', height: '16px'}}
                            //              src={imgPathPerfix() + "more_horizontal_white.png"}/>
                            //     </Dropdown>
                            // </div>
                        }


                        {//hover显示的菜单
                            props.data.id != 'add' && props.data.id != '-1' &&
                            <div className={'flex-row-vertical-center'} style={{
                                position: "absolute",
                                top: '8px',
                                right: '8px',
                                visibility: isHovered ? 'visible' : 'hidden'
                            }}
                                 onMouseEnter={() => setIsHoverdMore(true)} onMouseLeave={() => setIsHoverdMore(false)}
                                 onClick={(event) => {
                                     event.stopPropagation();
                                 }}>
                                {
                                    (!isAnnoType(props.data.type)) &&
                                    <Tooltip arrow={false} title={<div>
                                        {
                                            arrayTags.length == 0 ?
                                                <span>{t("Tags")}</span> :
                                                arrayTags.map((item, index) => {
                                                    return <span>{item + ((index == arrayTags.length - 1) ? '' : ' , ')}</span>
                                                })
                                        }
                                    </div>} onOpenChange={(e) => {
                                        if (e) {
                                            setArrayTags(props.data.tags || []);
                                        }
                                    }}>
                                        <img className={'img-24 ml-8'} src={getImagePathWithThemeSvg('library_tag')}
                                             onClick={() => {
                                                 getCardById(props.data.id).then(res => {
                                                     if (res) {
                                                         window.showManageTags([res],()=>{
                                                             if (isInJournal()){
                                                                 if (window.refreshMonthly){
                                                                     window.refreshMonthly();
                                                                 }
                                                             }
                                                         });
                                                     }
                                                 })
                                             }}/>
                                    </Tooltip>
                                }

                                {
                                    (isAnnoType(props.data.type)) &&
                                    <Tooltip arrow={false} title={t("Locate")}>
                                        <img className={'img-24 ml-8'}
                                             src={getImagePathWithThemeSvg('library_location')} onClick={() => {
                                            handleMenuClick({key: 'locateHighlight', item: props.data})
                                        }}/>
                                    </Tooltip>
                                }

                                {
                                    (props.from !== FROM_TRASH) &&
                                    <Tooltip arrow={false} title={t("Info")}>
                                        <img className={'img-24 ml-8'} src={getImagePathWithThemeSvg('library_info')}
                                             onClick={() => {
                                                 getCardById(props.data.id).then(res => {
                                                     if (res) {
                                                         window.showInfo('library', res);
                                                     }
                                                 })
                                             }}/>
                                    </Tooltip>
                                }
                                <Dropdown trigger={['click']} open={isShowMoreMenu_1} onOpenChange={(e) => {
                                    if (props.data?.isEmpty)return;
                                    //要改菜单的地方太多了。DYAMIC
                                    reContextMenu(e);
                                    setIsShowMoreMenu_1(e);
                                    setTimeout(() => {
                                        patchMenuFavor();
                                    }, 50)
                                }} menu={{items: menuItems, onClick: handleMenuClick}}>
                                    <Tooltip arrow={false} title={t("More")}>
                                        <img className={'img-24 ml-8'} src={getImagePathWithThemeSvg('library_more')}/>
                                    </Tooltip>
                                </Dropdown>
                            </div>
                        }

                        {
                            //gif...
                            // isGif(props.data.fileName) &&
                            // <div className={'flex-center'} style={{background:'var(--gif-tag-background-color)',width:'36px',height:'22px',borderRadius:'6px',position:'absolute',top:'4px',right:'4px'}}>
                            //     <span>GIF</span>
                            // </div>
                        }

                    </div>:<></>
                }


                {
                    // (props.from == FROM_TRASH || props.from == FROM_TAG) &&
                    // <div className={'home-list-item-name'}>
                    //     <span className='font-family-semi-bold ml-2' style={{
                    //         width: itemWidth,
                    //         overflow: 'hidden',
                    //         textOverflow: "ellipsis",
                    //         display: 'inline-block',
                    //         textAlign: 'left'
                    //     }}>{props.data.name}</span>
                    // </div>
                }

                </div>



                {
                    // props.tableView && props.tableView.columns.length > 0 &&
                    <>
                        {
                            props.data.id != '-1' &&
                            <>
                                <div className={'line'} style={{width: '100%'}}></div>
                                <GridViewPropertyInfo tableView={props.tableView} item={props.data} from={props.from}/>
                            </>
                        }
                    </>

                }

            </div>

        </Dropdown>
        // </Draggable>
    )
})
export default React.memo(CardItem);